<template>
	<div
		class="action-bar-container"
		:style="`height: calc(48px * ${actions.length})`"
	>
		<action
			v-for="action in actions"
			:key="action.id"
			:action="action"
			@open-action="openAction(action)"
		/>
	</div>
</template>

<script>
	import mixin from '@/shared/mixins';
	import action from './action';
	import bus from './../../../bus';

	function created() {
		const languages = window.localStorage.getItem('housekeeping::language');
		this.loadData(languages);
		bus.$on('get-language', (result) => {
			this.loadData(result);
		});
	}

	async function loadData(languages) {
		const baseUrl = `${process.env.ACL_URL}`;
		const appCode = `${process.env.APP_CODE}`;
		const uri = this.resourceUri;
		const params = { languages };
		const headers = {
			Accept: 'application/vnd.apiacl.v2+json',
		};
		const { data: actions } = await this.$http.get(`${baseUrl}/sidebar/${appCode}/resource/${uri}`,
			{ params, headers });
		const actionHelpEs = {
			id: actions.length + 1,
			code: 'HELP',
			icon: 'help',
			name: 'Necesitas Ayuda?',
		};
		const actionHelpEn = {
			id: actions.length + 1,
			code: 'HELP',
			icon: 'help',
			name: 'Need Help?',
		};
		const actionHelp = languages === 'en' ? actionHelpEn : actionHelpEs;
		this.actions = [];
		this.actions = actions.data.map((actionSingle) => {
			const newAction = { ...actionSingle };
			newAction.name = actionSingle.languages;
			return newAction;
		});
		this.actions.push(actionHelp);
	}

	function openAction(item) {
		this.$emit('run-action', item);
	}

	function data() {
		return {
			actions: [],
		};
	}

	export default {
		name: 'action-bar',
		components: {
			action,
		},
		created,
		data,
		methods: {
			loadData,
			openAction,
		},
		mixins: mixin,
		props: {
			resourceUri: {
				required: true,
				type: String,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.action-bar-container {
		bottom: 0;
		margin: auto 0;
		position: fixed;
		right: 0;
		text-align: right;
		top: 0;
		width: 0;
	}
</style>


// WEBPACK FOOTER //
// action-bar.vue?233ebca6